import { render } from "./ScrollerManager.vue?vue&type=template&id=3436b02e&scoped=true&ts=true"
import script from "./ScrollerManager.vue?vue&type=script&lang=ts"
export * from "./ScrollerManager.vue?vue&type=script&lang=ts"

import "./ScrollerManager.vue?vue&type=style&index=0&id=3436b02e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3436b02e"]])

export default __exports__